module.exports = [{
      plugin: require('/app/client/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"freeCodeCamp","short_name":"fCC","start_url":"/","theme_color":"#0a0a23","background_color":"#fff","display":"minimal-ui","icon":"src/assets/images/square_puck.png"},
    },{
      plugin: require('/app/client/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
